"use client";

import { useCallback } from "react";
import * as THREE from "three";

/**
 * THREE.js几何体构建模块
 * 负责创建和优化BufferGeometry
 */
export function useGeometryBuilder() {
  
  /**
   * 创建完整的点云几何体 (简化版)
   */
  const createPointGeometry = useCallback(
    (pointsArray: Float32Array, colorsArray: Float32Array): THREE.BufferGeometry => {
      const geometry = new THREE.BufferGeometry();

      // 设置位置属性
      geometry.setAttribute("position", new THREE.BufferAttribute(pointsArray, 3));

      // 设置颜色属性
      geometry.setAttribute("color", new THREE.BufferAttribute(colorsArray, 3));

      // 优化几何体性能
      geometry.computeBoundingBox();

      return geometry;
    },
    [],
  );

  /**
   * 清理几何体资源
   */
  const disposeGeometry = useCallback((geometry: THREE.BufferGeometry | null) => {
    if (geometry) {
      geometry.dispose();
    }
  }, []);

  return {
    createPointGeometry,
    disposeGeometry,
  };
}